import type { CobaltTableSortDirection } from '@cae/cobalt-react/components/table';
import type { InvoiceSortParam } from '@features/invoices/api/get-invoices/getInvoices.types';

import type {
  InvoiceTableColumn,
  InvoiceSortField,
  InvoiceSortState,
} from './InvoicesTable.types';

export const TABLE_COLUMNS: InvoiceTableColumn[] = [
  {
    id: 'transactionNumber',
    label: 'Invoice number',
    width: '12.5rem',
  },
  {
    id: 'issuedOn',
    label: 'Issued on',
    width: 'var(--space-160)',
  },
  {
    id: 'dueDate',
    label: 'Due date',
    width: 'var(--space-160)',
  },
  {
    id: 'outstandingAmount',
    label: 'Outstanding amount',
    width: '12.5rem',
  },
  {
    id: 'pilotNames',
    label: 'Crew member',
    width: 'var(--space-160)',
  },
  {
    id: 'schedulerReservationIds',
    label: 'Reservation number',
    width: 'var(--space-160)',
  },
  {
    id: 'legalEntityName',
    label: 'Legal entity',
    width: 'var(--space-160)',
  },
  {
    id: 'poNumbers',
    label: 'PO number',
    width: 'var(--space-160)',
  },
  {
    id: 'download',
    label: '',
    ariaLabel: 'Actions',
    sortable: false,
    width: '4.5rem',
  },
];

const COLUMN_TO_API_FIELD: Record<InvoiceSortField, string> = {
  outstandingAmount: 'amount',
  transactionNumber: 'invoiceNumber',
  dueDate: 'dueDate',
  issuedOn: 'issuedOn',
  legalEntityName: 'legal',
  pilotNames: 'crew',
  schedulerReservationIds: 'reservationNumber',
  poNumbers: 'poNumber',
  download: 'download',
};

const API_FIELD_TO_COLUMN: Record<string, InvoiceSortField> = {
  amount: 'outstandingAmount',
  invoiceNumber: 'transactionNumber',
  dueDate: 'dueDate',
  issuedOn: 'issuedOn',
  legal: 'legalEntityName',
  crew: 'pilotNames',
  reservationNumber: 'schedulerReservationIds',
  poNumber: 'poNumbers',
};

export function toApiSortParam(
  column: InvoiceSortField | '',
  direction: CobaltTableSortDirection
): InvoiceSortParam | undefined {
  if (!column || !direction) return undefined;
  const prefix = direction === 'asc' ? '+' : '-';
  return `${prefix}${COLUMN_TO_API_FIELD[column]}` as InvoiceSortParam;
}

export function fromApiSortParam(
  sort: InvoiceSortParam | undefined
): InvoiceSortState {
  if (!sort) return { column: '', direction: false };
  const prefix = sort[0];
  const field = sort.slice(1);
  const column = API_FIELD_TO_COLUMN[field];
  if (!column) return { column: '', direction: false };
  return { column, direction: prefix === '+' ? 'asc' : 'desc' };
}
